import { SectionOfDashboard } from "@/modules/DashboardTemplate/models/SectionOfDashboard";
import { Utils } from "@/shared/utils/utils";
import { Component, Prop, Vue } from "vue-property-decorator";
import { mapGetters } from "vuex";

@Component({
  name: "DoughnutChart",
  computed: {
    ...mapGetters({
      sectionsOfDashboardStore: "getSectionsOfdashboard"
    })
  }
})
export default class DoughnutChart extends Vue {
  sectionsOfDashboardStore!: Array<SectionOfDashboard>;

  @Prop() propertiesToChart!: {
    //chartName: string,
    indexSectionOfDashboard: number;
    indexCollectionFilter: number;
    groupBy: [];
    chartColor: { hex: string };
    // seeBy: [],
    // collectionField: [{ name: string }],
    // xAxis: [],
    // yAxis: []
  };

  chartOptions = {};

  mounted() {
    this.chart();
  }

  chart() {
    const dataToGraph = this.sectionsOfDashboardStore[
      this.propertiesToChart.indexSectionOfDashboard
    ].collections[0];
    console.log("mounted dona", dataToGraph);
    const seriesData = [];
    for (let i = 0; i < dataToGraph.chartData.xAxis.length; i++) {
      seriesData.push({
        name: dataToGraph.chartData.xAxis[i],
        value: dataToGraph.chartData.data[0].data[i]
      });
    }

    this.chartOptions = {
      color: Utils.generateColorsTones(
        this.propertiesToChart.chartColor.hex,
        3
      ) as never[],
      title: {
        text: dataToGraph.chartName,
        left: "center"
      },
      tooltip: {
        trigger: "item"
      },
      legend: {
        orient: "horizontal",
        left: "top"
      },
      series: [
        {
          name: dataToGraph.chartName,
          type: "pie",
          radius: ["40%", "70%"],
          avoidLabelOverlap: false,
          itemStyle: {
            borderRadius: 10,
            borderColor: "#fff",
            borderWidth: 2
          },
          label: {
            show: false,
            position: "center"
          },
          emphasis: {
            label: {
              show: true,
              fontSize: 20,
              fontWeight: "bold"
            }
          },
          labelLine: {
            show: false
          },
          data: seriesData
        }
      ]
    };
  }
}
